import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import CommitteeCard from './CommitteeCard'

interface CommitteeData {
  allMdx: {
    nodes: Array<{
      id: string
      frontmatter: {
        name: string
        role: string
        order: number
        image?: string // URL string like "/uploads/img_4385.jpg"
      }
      fields: {
        slug: string
      }
    }>
  }
}

const CommitteeList: React.FC = () => {
  const data = useStaticQuery<CommitteeData>(graphql`
    query CommitteeListQuery {
      allMdx(
        filter: { internal: { contentFilePath: { regex: "/content/committee/" } } }
        sort: { frontmatter: { order: ASC } }
      ) {
        nodes {
          id
          frontmatter {
            name
            role
            order
            image
          }
          fields {
            slug
          }
        }
      }
    }
  `)

  const committeeMembers = data.allMdx.nodes

  if (!committeeMembers || committeeMembers.length === 0) {
    return (
      <div className="text-center py-16">
        <h2 className="text-2xl font-semibold text-text-light mb-4">
          No committee members found
        </h2>
        <p className="text-text-light">
          Committee members will appear here once they're added to the system.
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
      {committeeMembers.map((member) => (
        <CommitteeCard
          key={member.id}
          name={member.frontmatter.name}
          role={member.frontmatter.role}
          image={member.frontmatter.image}
          slug={member.fields.slug}
        />
      ))}
    </div>
  )
}

export default CommitteeList